import { pickBy } from '@/utils'

export default {
  name: 'memberTask',
  setting: [
    {
      label: '积分数量颜色',
      key: 'pointsColor',
      component: 'color',
      value: '#5875F8'
    },
    {
      label: '导航按钮背景色',
      key: 'buttonBackgroundColor',
      component: 'color',
      value: '#5875F8'
    },
    {
      label: '导航按钮文字颜色',
      key: 'buttonTextColor',
      component: 'color',
      value: '#ffffff'
    }
  ],
  transformIn: (v) => {
    const { name, base, config } = v
    return {
      name,
      ...base,
      ...config
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: () => {
        return {}
      },
      config: (v) => {
        return pickBy(v, {
          pointsColor: 'pointsColor',
          buttonBackgroundColor: 'buttonBackgroundColor',
          buttonTextColor: 'buttonTextColor'
        })
      }
    })
  }
}

